module.exports = __webpack_public_path__ + "img/蒙版组 1@2x (4).008b3719.webp";